import React, { Component } from 'react'
import { PaperScope } from 'paper/dist/paper-core'
import FileSaver from 'file-saver'
import { contrastColors } from '../colorProcedures'
import Color from 'color'
// import i18n from '../i18n.json'

const findLogo = (currentChildren) => {
  if (currentChildren.hasChildren) {
    if (currentChildren.hasChildren()) {
      if (currentChildren.children['logo']) {
        return currentChildren.children['logo']
      }
      else {
        for (let i = 0; i < currentChildren.children.length; i++) {
          let checkChildren = findLogo(currentChildren.children[i])
          if (checkChildren) return checkChildren
        }
      }
    }
  }
  return null
}

class BrandGuideline extends Component {
  constructor(props) {
    super(props)
    this.state = {
      colorPalette: [],
      guideline: null,
      bestBackgroundColor: "#fff",
      bestBackgroundBlackOrWhite: "#fff"
    }
  }

  componentWillMount() {
    let brandId = this.props.match.params.id
    this.props.getGuideline(brandId)
    .then((guideline) => {
      if (guideline.length <= 0) return null
      let { elements } = guideline[0]
      let { colorPalette } = elements
      let colors = Object.values(colorPalette.colors)
      if (colorPalette.colored) {
        colors[0] = colorPalette.colored[0]
        colors[1] = colorPalette.colored[1]
        colors[4] = colorPalette.colorBackground
      }
      else if (colorPalette.light) {
        colors[0] = colorPalette.light[0]
        colors[1] = colorPalette.light[1]
      }
      if (colorPalette.dark) {
        colors[2] = colorPalette.dark[0]
        colors[3] = colorPalette.dark[1]
      }
      let colorsDark = Object.values(colorPalette.colors)
      if (colorPalette.dark) {
        colorsDark[0] = colorPalette.dark[0]
        colorsDark[1] = colorPalette.dark[1]
      }

      // if (colors[4] === "") colors[4] = contrastColors(colors[2], colors).contrasts[0]

      let mixed = Color(colors[0]).mix(Color(colors[1]))
      let bestBackgroundBlackOrWhite = Color(contrastColors(mixed, [].concat(Color('white')).concat(Color('black'))).contrasts[0])
      let contrastBoth = contrastColors(mixed, colors).contrasts
      let bestBackgroundColor = Color(contrastBoth[0]).string()
      if (colorPalette.colorBackground) {
        bestBackgroundColor = colorPalette.colorBackground
      }

      this.setState({
        colorPalette: colors,
        bestBackgroundBlackOrWhite: bestBackgroundBlackOrWhite.string(),
        bestBackgroundColor,
        guideline: guideline[0]
      })
    })
  }

  componentDidUpdate() {
    if (!this.state.guideline) return null
    let { svg, elements } = this.state.guideline
    if (!svg) return null
    let uriSVG = null
    let uriSVGDark = null
    if (svg.light) uriSVG = "data:image/svg+xml;utf8," + encodeURIComponent(svg.light)
    else uriSVG = "data:image/svg+xml;utf8," + encodeURIComponent(svg)
    if (svg.dark) uriSVGDark = "data:image/svg+xml;utf8," + encodeURIComponent(svg.dark)
    let { colorPalette } = elements
    let colorsDark = Object.values(colorPalette.colors)
    if (colorPalette.dark) {
      colorsDark[0] = colorPalette.dark[0]
      colorsDark[1] = colorPalette.dark[1]
    }

    let base0 = this.state.colorPalette[0]
    let palette0 = contrastColors(base0, this.state.colorPalette)
    let base1 = this.state.colorPalette[1]
    let palette1 = contrastColors(base1, this.state.colorPalette)
    let base2 = this.state.colorPalette[2]
    let palette2 = contrastColors(base2, this.state.colorPalette)
    let base3 = this.state.colorPalette[3]
    let palette3 = contrastColors(base3, this.state.colorPalette)
    // if (this.state.colorPalette[4] === "") this.state.colorPalette[4] = palette2.contrasts
    let base4 = this.state.colorPalette[4]
    let palette4 = contrastColors(base4, this.state.colorPalette)
    let paletteWhite = contrastColors('#ffffff', this.state.colorPalette)
    let paletteBlack = contrastColors('#000000', colorsDark)

    let assets = [
      { refId: 'logoAsPNG', width: 1200, height: 1200, background: null},
      { refId: 'logoAsPNGThumb', width: 150, height: 150, background: null},
      { refId: 'logoAsPNGPalette', width: 1200, height: 1200, background: this.state.bestBackgroundColor},
      { refId: 'logoAsPNGPaletteThumb', width: 150, height: 150, background: this.state.bestBackgroundColor},
      { refId: 'logoAsPNGMono1', width: 1200, height: 1200, background: this.state.bestBackgroundColor, palette: this.state.colorPalette },
      { refId: 'logoAsPNGMono1Thumb', width: 150, height: 150, background: this.state.bestBackgroundColor, palette: this.state.colorPalette },
      { refId: 'logoAsPNGMono2', width: 1200, height: 1200, background: this.state.bestBackgroundColor, palette: [this.state.colorPalette[1]] },
      { refId: 'logoAsPNGMono2Thumb', width: 150, height: 150, background: this.state.bestBackgroundColor, palette: [this.state.colorPalette[1]] },
      { refId: 'logoAsPNGBlackOrWhiteBackground', width: 1200, height: 1200, background: this.state.bestBackgroundBlackOrWhite},
      { refId: 'logoAsPNGBlackOrWhiteBackgroundThumb', width: 150, height: 150, background: this.state.bestBackgroundBlackOrWhite},
      { refId: 'logoAsPNGWhite', width: 1200, height: 1200, background: '#ffffff', palette: paletteWhite.contrasts },
      { refId: 'logoAsPNGWhiteThumb', width: 150, height: 150, background: '#ffffff', palette: paletteWhite.contrasts },
      { refId: 'logoAsPNGDark', width: 1200, height: 1200, background: '#000000', svgStyle: 'dark' },
      { refId: 'logoAsPNGDarkThumb', width: 150, height: 150, background: '#000000', svgStyle: 'dark' },
      { refId: 'logoAsPNGBlack', width: 1200, height: 1200, background: '#000000', palette: paletteBlack.contrasts },
      { refId: 'logoAsPNGBlackThumb', width: 150, height: 150, background: '#000000', palette: paletteBlack.contrasts },
      { refId: 'logoAsPNGPalette0', width: 1200, height: 1200, background: base0, palette: palette0.contrasts },
      { refId: 'logoAsPNGPalette0Thumb', width: 150, height: 150, background: base0, palette: palette0.contrasts },
      { refId: 'logoAsPNGPalette1', width: 1200, height: 1200, background: base1, palette: palette1.contrasts },
      { refId: 'logoAsPNGPalette1Thumb', width: 150, height: 150, background: base1, palette: palette1.contrasts },
      { refId: 'logoAsPNGPalette2', width: 1200, height: 1200, background: base2, palette: palette2.contrasts },
      { refId: 'logoAsPNGPalette2Thumb', width: 150, height: 150, background: base2, palette: palette2.contrasts },
      { refId: 'logoAsPNGPalette3', width: 1200, height: 1200, background: base3, palette: palette3.contrasts },
      { refId: 'logoAsPNGPalette3Thumb', width: 150, height: 150, background: base3, palette: palette3.contrasts },
      { refId: 'logoAsPNGPalette4', width: 1200, height: 1200, background: base4, palette: palette4.contrasts },
      { refId: 'logoAsPNGPalette4Thumb', width: 150, height: 150, background: base4, palette: palette4.contrasts },

      // Facebook
      // Cover: 1200x675 -> 2400x1350
      // Profile: 340x340 -> 680x680
      { refId: 'facebookProfileLight', width: 680, height: 680, background: this.state.bestBackgroundBlackOrWhite },
      { refId: 'facebookProfileLightThumb', width: 200, height: 200, background: this.state.bestBackgroundBlackOrWhite },
      { refId: 'facebookCoverLight', width: 2400, height: 1350, background: this.state.bestBackgroundBlackOrWhite },
      { refId: 'facebookCoverLightThumb', width: 400, height: 150, background: this.state.bestBackgroundBlackOrWhite },
      { refId: 'facebookProfileDark', width: 680, height: 680, background: '#000000', svgStyle: 'dark' },
      { refId: 'facebookProfileDarkThumb', width: 200, height: 200, background: '#000000', svgStyle: 'dark' },
      { refId: 'facebookCoverDark', width: 2400, height: 1350, background: '#000000', svgStyle: 'dark' },
      { refId: 'facebookCoverDarkThumb', width: 400, height: 150, background: '#000000', svgStyle: 'dark' },
      { refId: 'facebookProfilePalette', width: 680, height: 680, background: this.state.bestBackgroundColor },
      { refId: 'facebookProfilePaletteThumb', width: 200, height: 200, background: this.state.bestBackgroundColor },
      { refId: 'facebookCoverPalette', width: 2400, height: 1350, background: this.state.bestBackgroundColor },
      { refId: 'facebookCoverPaletteThumb', width: 400, height: 150, background: this.state.bestBackgroundColor },

      // Twitter
      // Header: 1500x500 -> 3000x1000
      // Profile: 400x400 -> 800x800
      { refId: 'twitterProfileLight', width: 800, height: 800, background: this.state.bestBackgroundBlackOrWhite },
      { refId: 'twitterProfileLightThumb', width: 200, height: 200, background: this.state.bestBackgroundBlackOrWhite },
      { refId: 'twitterCoverLight', width: 3000, height: 1000, background: this.state.bestBackgroundBlackOrWhite },
      { refId: 'twitterCoverLightThumb', width: 300, height: 100, background: this.state.bestBackgroundBlackOrWhite },
      { refId: 'twitterProfileDark', width: 800, height: 800, background: '#000000', svgStyle: 'dark' },
      { refId: 'twitterProfileDarkThumb', width: 200, height: 200, background: '#000000', svgStyle: 'dark' },
      { refId: 'twitterCoverDark', width: 3000, height: 1000, background: '#000000', svgStyle: 'dark' },
      { refId: 'twitterCoverDarkThumb', width: 300, height: 100, background: '#000000', svgStyle: 'dark' },
      { refId: 'twitterProfilePalette', width: 800, height: 800, background: this.state.bestBackgroundColor },
      { refId: 'twitterProfilePaletteThumb', width: 200, height: 200, background: this.state.bestBackgroundColor },
      { refId: 'twitterCoverPalette', width: 3000, height: 1000, background: this.state.bestBackgroundColor },
      { refId: 'twitterCoverPaletteThumb', width: 300, height: 100, background: this.state.bestBackgroundColor },

      // Linkedin
      // Company Cover: 1536x768 -> 3072x1536
      // Company Logo: 300x300 -> 600x600
      { refId: 'linkedinProfileLight', width: 600, height: 600, background: this.state.bestBackgroundBlackOrWhite },
      { refId: 'linkedinProfileLightThumb', width: 200, height: 200, background: this.state.bestBackgroundBlackOrWhite },
      { refId: 'linkedinCoverLight', width: 3072, height: 1536, background: this.state.bestBackgroundBlackOrWhite },
      { refId: 'linkedinCoverLightThumb', width: 384, height: 192, background: this.state.bestBackgroundBlackOrWhite },
      { refId: 'linkedinProfileDark', width: 600, height: 600, background: '#000000', svgStyle: 'dark' },
      { refId: 'linkedinProfileDarkThumb', width: 200, height: 200, background: '#000000', svgStyle: 'dark' },
      { refId: 'linkedinCoverDark', width: 3072, height: 1536, background: '#000000', svgStyle: 'dark' },
      { refId: 'linkedinCoverDarkThumb', width: 384, height: 192, background: '#000000', svgStyle: 'dark' },
      { refId: 'linkedinProfilePalette', width: 600, height: 600, background: this.state.bestBackgroundColor },
      { refId: 'linkedinProfilePaletteThumb', width: 200, height: 200, background: this.state.bestBackgroundColor },
      { refId: 'linkedinCoverPalette', width: 3072, height: 1536, background: this.state.bestBackgroundColor },
      { refId: 'linkedinCoverPaletteThumb', width: 384, height: 192, background: this.state.bestBackgroundColor },

      // Instagram
      // Profile: 180x180 -> 360x360
      { refId: 'instagramProfileLight', width: 360, height: 360, background: this.state.bestBackgroundBlackOrWhite },
      { refId: 'instagramProfileLightThumb', width: 180, height: 180, background: this.state.bestBackgroundBlackOrWhite },
      { refId: 'instagramProfileDark', width: 360, height: 360, background: '#000000', svgStyle: 'dark' },
      { refId: 'instagramProfileDarkThumb', width: 180, height: 180, background: '#000000', svgStyle: 'dark' },
      { refId: 'instagramProfilePalette', width: 360, height: 360, background: this.state.bestBackgroundColor },
      { refId: 'instagramProfilePaletteThumb', width: 180, height: 180, background: this.state.bestBackgroundColor },

    ]
    assets.forEach((asset) => {
      let { refId, width, height, background, palette, svgStyle } = asset

      let canvas = this.refs[refId]
      if (!canvas) return
      // Set canvas dimensions
      canvas.width = width
      canvas.height = height

      let paper = new PaperScope().setup(canvas)
      // Setup canvas
      paper.view.setViewSize(width, height)

      // Draw background if not null
      if (background) {
        let bg = new paper.Path.Rectangle({
            point: [0, 0],
            size: [width, height],
            selected: false,
            fillColor: background
        })
        bg.sendToBack()
      }
      let uri = (svgStyle === 'dark' && uriSVGDark) ? uriSVGDark : uriSVG
      paper.project.importSVG(uri, {
        insert: true,
        onLoad: (item) => {
          item.applyMatrix = false
          let padding = Math.ceil(Math.min(width/3, height/3)/2)
          let widthScale = (width-padding*2)/item.bounds.width
          let heightScale = (height-padding*2)/item.bounds.height
          item.scale(Math.min(widthScale, heightScale))
          item.bounds.center = paper.view.bounds.center
          // item.fitBounds(paper.view.bounds)
          if (palette) {
            let logo = findLogo(item) || item
            let children = logo.children
            for (let i = 0; i < children.length; i++) {
              if (children[i].fillColor) children[i].fillColor = palette[0]
              if (children[i].strokeColor) children[i].strokeColor = palette[0]
              if (!children[i].fillColor && !children[i].strokeColor) children[i].fillColor = palette[0]
            }
          }
        },
        onError: (message) => {
          //console.error(message)
        }
      })
    })
  }

  saveSVG(evt, svg, brandName) {
    evt.preventDefault()
    let blob = new Blob([svg], {type: 'image/svg+xml'})
    FileSaver.saveAs(blob, `${brandName}_logo.svg`)
  }

  saveCanvas(evt, refId) {
    evt.preventDefault()
    let canvas = this.refs[refId]
    if (!canvas) return
    canvas.toBlob((blob) => {
      FileSaver.saveAs(blob, `${refId}.png`)
    }, 'image/png', 1)
  }

  render() {
    if (!this.state.guideline) return null
    let { svg, brandName, elements } = this.state.guideline
    if (!svg) return null
    let uriSVG = null
    let uriSVGDark = null
    if (svg.light) uriSVG = "data:image/svg+xml;utf8," + encodeURIComponent(svg.light)
    else uriSVG = "data:image/svg+xml;utf8," + encodeURIComponent(svg)
    if (svg.dark) uriSVGDark = "data:image/svg+xml;utf8," + encodeURIComponent(svg.dark)

    let contrastsA = contrastColors(this.state.colorPalette[0], this.state.colorPalette).contrasts
    let contrastsB = contrastColors(this.state.colorPalette[1], this.state.colorPalette).contrasts

    let contrastsC = contrastColors(this.state.colorPalette[2], this.state.colorPalette).contrasts
    let contrastsE = contrastColors(contrastsA[0], this.state.colorPalette).contrasts
    let colorsO = this.state.colorPalette.map((co) => {
      return Color(co)
    })
    return (
      <div className="brand-guideline" style={{ backgroundColor: "#fff" }}>
        <div className="brand-section" style={{ padding: "50px", backgroundColor: Color(this.state.bestBackgroundColor).alpha(0.5) }}>

          <div className="flex-row">

            <div className="col-6">
              <img className="transparentLogo" src={ uriSVG } alt="Logo (SVG)"/>
            </div>

            <div className="col-6">
              <div className="landing-box" style={{ color: this.state.colorPalette[0] }}>
                  <div className="brand-guideline-title" style={{ color: this.state.colorPalette[0] }}>
                    Brand Guideline
                  </div>

                <p>
                  A <i>Brand Guideline</i> or <i>Style Guide</i> is a set of standards to ensure a consistent design and identity.
                  <br /><br />
                  Scroll down to find color palettes, fonts, logo sizes, and everything else about your brand.
                </p>
              </div>
            </div>

          </div>

        </div>

        <div className="brand-section" style={{ padding: "50px", backgroundColor: Color(this.state.colorPalette[2]).alpha(0.3)}}>

          <div className="brand-guideline-subtitle" style={{ color: contrastsC[1] }}>
            Logo Files
          </div>

          <div className="" style={{ color: contrastsC[0]}}>
            <h2>Vectorial</h2>
            <p>Scalable, ideal to place on any asset you want.</p>
          </div>
          <div className="row" style={{ textAlign: "right" }}>

            <div className="col-3">
              <img src={ uriSVG } alt="Logo (SVG)" style={{ padding: "20px", backgroundColor:"#ffffffa3" }}/>
              <div className="brand-guideline-button">
                <a href="/export" onClick={ (evt) => { this.saveSVG(evt, svg.light || svg, brandName) } }>
                  <i className="fa fa-arrow-down user-icon"></i>
                  Download Vectorial
                </a>
              </div>
            </div>
            { svg.dark
              ?
              <div className="col-3">
                <img src={ uriSVGDark } alt="Logo Dark (SVG)" style={{ padding: "20px", backgroundColor:"#000000a3" }}/>
                <div className="brand-guideline-button">
                  <a href="/export" onClick={ (evt) => { this.saveSVG(evt, svg.dark, brandName) } }>
                    <i className="fa fa-arrow-down user-icon"></i>
                    Download Vectorial
                  </a>
                </div>
              </div>
              : null
            }
          </div>

          <div className="" style={{ color: contrastsC[0]}}>
            <h2>Bitmap</h2>
            <p>Non-scalable, use on websites and other static places.</p>
          </div>

          <div className="" style={{ color: contrastsC[0]}}>
            <p>{ "Variations of the original logo:"}</p>
          </div>

        <div className="row" style={{ textAlign: "right" }}>
          <div className="col-2" >
            <div className="canvas-wrapper">
              <div className="canvas-dim"><h1>1200 x 1200</h1></div>
              <canvas className="wrapped-canvas" ref="logoAsPNG" data-paper-hidpi="false"/>
            </div>
            <canvas ref="logoAsPNGThumb" data-paper-hidpi="true" style={{ backgroundColor:"#ffffffa3" }}/>
            <div className="brand-guideline-button">
              <a href="/export" onClick={ (evt) => { this.saveCanvas(evt, "logoAsPNG") } }>
                <i className="fa fa-arrow-down user-icon"></i>
                Download Transparent
              </a>
            </div>
          </div>

          <div className="col-2">
            <div className="canvas-wrapper">
              <div className="canvas-dim"><h1>1200 x 1200</h1></div>
              <canvas ref="logoAsPNGPalette" data-paper-hidpi="false"/>
            </div>
            <canvas ref="logoAsPNGPaletteThumb" data-paper-hidpi="true"/>
            <div className="brand-guideline-button">
              <a href="/export" onClick={ (evt) => { this.saveCanvas(evt, "logoAsPNGPalette") } }>
                <i className="fa fa-arrow-down user-icon"></i>
                Download Original
              </a>
            </div>
          </div>

          <div className="col-2">
            <div className="canvas-wrapper">
              <div className="canvas-dim"><h1>1200 x 1200</h1></div>
              <canvas ref="logoAsPNGMono1" data-paper-hidpi="false"/>
            </div>
            <canvas ref="logoAsPNGMono1Thumb" data-paper-hidpi="true"/>
            <div className="brand-guideline-button">
              <a href="/export" onClick={ (evt) => { this.saveCanvas(evt, "logoAsPNGMono1") } }>
                <i className="fa fa-arrow-down user-icon"></i> Download
              </a>
            </div>
          </div>

          <div className="col-2">
            <div className="canvas-wrapper">
              <div className="canvas-dim"><h1>1200 x 1200</h1></div>
              <canvas ref="logoAsPNGMono2" data-paper-hidpi="false"/>
            </div>
            <canvas ref="logoAsPNGMono2Thumb" data-paper-hidpi="true"/>
            <div className="brand-guideline-button">
              <a href="/export" onClick={ (evt) => { this.saveCanvas(evt, "logoAsPNGMono2") } }>
                <i className="fa fa-arrow-down user-icon"></i> Download
              </a>
            </div>
          </div>

        </div>

        <div className="" style={{ color: contrastsC[0]}}>
          <p>{ "Variations using black and white as background colors:"}</p>
        </div>

        <div className="row" style={{ textAlign: "right" }}>
            <div className="col-2">
              <div className="canvas-wrapper">
                <div className="canvas-dim"><h1>1200 x 1200</h1></div>
                <canvas ref="logoAsPNGWhite" data-paper-hidpi="false"/>
              </div>
              <canvas ref="logoAsPNGWhiteThumb" data-paper-hidpi="true"/>
              <div className="brand-guideline-button">
                <a href="/export" onClick={ (evt) => { this.saveCanvas(evt, "logoAsPNGWhite") } }>
                  <i className="fa fa-arrow-down user-icon"></i> Download
                </a>
              </div>
            </div>

            <div className="col-2">
              <div className="canvas-wrapper">
                <div className="canvas-dim"><h1>1200 x 1200</h1></div>
                <canvas ref="logoAsPNGBlackOrWhiteBackground" data-paper-hidpi="false"/>
              </div>
              <canvas ref="logoAsPNGBlackOrWhiteBackgroundThumb" data-paper-hidpi="true"/>
              <div className="brand-guideline-button">
                <a href="/export" onClick={ (evt) => { this.saveCanvas(evt, "logoAsPNGBlackOrWhiteBackground") } }>
                  <i className="fa fa-arrow-down user-icon"></i> Download
                </a>
              </div>
            </div>

            { svg.dark
              ?
              <div className="col-2">
                <div className="canvas-wrapper">
                  <div className="canvas-dim"><h1>1200 x 1200</h1></div>
                  <canvas ref="logoAsPNGDark" data-paper-hidpi="false"/>
                </div>
                <canvas ref="logoAsPNGDarkThumb" data-paper-hidpi="true"/>
                <div className="brand-guideline-button">
                  <a href="/export" onClick={ (evt) => { this.saveCanvas(evt, "logoAsPNGDark") } }>
                    <i className="fa fa-arrow-down user-icon"></i> Download
                  </a>
                </div>
              </div>
              : null
            }

            <div className="col-2">
              <div className="canvas-wrapper">
                <div className="canvas-dim"><h1>1200 x 1200</h1></div>
                <canvas ref="logoAsPNGBlack" data-paper-hidpi="false"/>
              </div>
              <canvas ref="logoAsPNGBlackThumb" data-paper-hidpi="true"/>
              <div className="brand-guideline-button">
                <a href="/export" onClick={ (evt) => { this.saveCanvas(evt, "logoAsPNGBlack") } }>
                  <i className="fa fa-arrow-down user-icon"></i> Download
                </a>
              </div>
            </div>
        </div>

        <div className="" style={{ color: contrastsC[0]}}>
          <p>{ "Variations using brand's color palette:"}</p>
        </div>

        <div className="row" style={{ textAlign: "right" }}>
          <div className="col-2">
            <div className="canvas-wrapper">
              <div className="canvas-dim"><h1>1200 x 1200</h1></div>
              <canvas ref="logoAsPNGPalette0" data-paper-hidpi="false"/>
            </div>
            <canvas ref="logoAsPNGPalette0Thumb" data-paper-hidpi="true"/>
            <div className="brand-guideline-button">
              <a href="/export" onClick={ (evt) => { this.saveCanvas(evt, "logoAsPNGPalette0") } }>
                <i className="fa fa-arrow-down user-icon"></i> Download
              </a>
            </div>
          </div>

          <div className="col-2">
            <div className="canvas-wrapper">
              <div className="canvas-dim"><h1>1200 x 1200</h1></div>
              <canvas ref="logoAsPNGPalette1" data-paper-hidpi="false"/>
            </div>
            <canvas ref="logoAsPNGPalette1Thumb" data-paper-hidpi="true"/>
            <div className="brand-guideline-button">
              <a href="/export" onClick={ (evt) => { this.saveCanvas(evt, "logoAsPNGPalette1") } }>
                <i className="fa fa-arrow-down user-icon"></i> Download
              </a>
            </div>
          </div>

          <div className="col-2">
            <div className="canvas-wrapper">
              <div className="canvas-dim"><h1>1200 x 1200</h1></div>
            <canvas ref="logoAsPNGPalette2" data-paper-hidpi="false"/>
            </div>
            <canvas ref="logoAsPNGPalette2Thumb" data-paper-hidpi="true"/>
            <div className="brand-guideline-button">
              <a href="/export" onClick={ (evt) => { this.saveCanvas(evt, "logoAsPNGPalette2") } }>
                <i className="fa fa-arrow-down user-icon"></i> Download
              </a>
            </div>
          </div>

          <div className="col-2">
            <div className="canvas-wrapper">
              <div className="canvas-dim"><h1>1200 x 1200</h1></div>
              <canvas ref="logoAsPNGPalette3" data-paper-hidpi="false"/>
            </div>
            <canvas ref="logoAsPNGPalette3Thumb" data-paper-hidpi="true"/>
            <div className="brand-guideline-button">
              <a href="/export" onClick={ (evt) => { this.saveCanvas(evt, "logoAsPNGPalette3") } }>
                <i className="fa fa-arrow-down user-icon"></i> Download
              </a>
            </div>
          </div>

          <div className="col-2">
            <div className="canvas-wrapper">
              <div className="canvas-dim"><h1>1200 x 1200</h1></div>
              <canvas ref="logoAsPNGPalette4" data-paper-hidpi="false"/>
            </div>
            <canvas ref="logoAsPNGPalette4Thumb" data-paper-hidpi="true"/>
            <div className="brand-guideline-button">
              <a href="/export" onClick={ (evt) => { this.saveCanvas(evt, "logoAsPNGPalette4") } }>
                <i className="fa fa-arrow-down user-icon"></i> Download
              </a>
            </div>
          </div>

        </div>
      </div>

    { elements.brandTypeface || elements.sloganTypeface
      ?
        <div className="brand-section" style={{ padding: "50px", backgroundColor: Color(this.state.colorPalette[1]).alpha(0.3)}}>

          <div className="brand-guideline-subtitle" style={{ color: contrastsB[1]}}>
            Typefaces
          </div>

          <div className="row" style={{ color: contrastsB[0]}}>
            { elements.brandTypeface
              ?
              <div className="col-2">
                <h2>{ elements.brandTypeface.name }</h2>
                <p>Your Brand Typeface is the <b> { elements.brandTypeface.name }</b></p>
                <p>The Author is <b> { elements.brandTypeface.author }</b></p>
                <p>Click <a href={elements.brandTypeface.source}>here</a> to go to the original page for download</p>
              </div>
              : null
            }
            { elements.sloganTypeface
              ?
              <div className="col-2">
                <h2>{ elements.sloganTypeface.name }</h2>
                <p>Your Slogan Typeface is the <b>{ elements.sloganTypeface.name }</b></p>
                <p>The Author is <b>{ elements.sloganTypeface.author }</b></p>
                <p>Click <a href={elements.sloganTypeface.source}>here</a> to go to the original page for download</p>
              </div>
              : null
            }
          </div>

      </div>
      : null
    }

      <div className="brand-section" style={{ padding: "50px", backgroundColor: Color(contrastsA[0]).alpha(0.3)}}>
        <div className="brand-guideline-subtitle" style={{ color: contrastsE[1]}}>
          Colors
        </div>

        <div className="row">
          <div className="col-2">
            <div className="a-color" style={ { backgroundColor: this.state.colorPalette[0] } }></div>
            <div className="color-data" style={ { color: contrastsE[0] } }>
            <p>{ this.state.colorPalette[0] }</p>
            <ul>
              <li>R <span className="color-data-value">{ colorsO[0].red() }</span></li>
              <li>G <span className="color-data-value">{ colorsO[0].green() }</span></li>
              <li>B <span className="color-data-value">{ colorsO[0].blue() }</span></li>
            </ul>
            <ul>
              <li>H <span className="color-data-value">{ colorsO[0].hue().toFixed(2) }</span></li>
              <li>S <span className="color-data-value">{ colorsO[0].saturationl().toFixed(2) }</span></li>
              <li>L <span className="color-data-value">{ colorsO[0].lightness().toFixed(2) }</span></li>
            </ul>
            <ul>
              <li>H <span className="color-data-value">{ colorsO[0].hue().toFixed(2) }</span></li>
              <li>S <span className="color-data-value">{ colorsO[0].saturationv().toFixed(2) }</span></li>
              <li>V <span className="color-data-value">{ colorsO[0].lightness().toFixed(2) }</span></li>
            </ul>
            <ul>
              <li>C <span className="color-data-value">{ colorsO[0].cyan().toFixed(2) }</span></li>
              <li>M <span className="color-data-value">{ colorsO[0].magenta().toFixed(2) }</span></li>
              <li>Y <span className="color-data-value">{ colorsO[0].yellow().toFixed(2) }</span></li>
              <li>K <span className="color-data-value">{ colorsO[0].black().toFixed(2) }</span></li>
            </ul>
            </div>
          </div>

          <div className="col-2">
            <div className="a-color" style={ { backgroundColor: this.state.colorPalette[1] } }>
            </div>
            <div className="color-data" style={ { color: contrastsE[0] } }>
            <p>{ this.state.colorPalette[1] }</p>
            <ul>
              <li>R <span className="color-data-value">{ colorsO[1].red() }</span></li>
              <li>G <span className="color-data-value">{ colorsO[1].green() }</span></li>
              <li>B <span className="color-data-value">{ colorsO[1].blue() }</span></li>
            </ul>
            <ul>
              <li>H <span className="color-data-value">{ colorsO[1].hue().toFixed(2) }</span></li>
              <li>S <span className="color-data-value">{ colorsO[1].saturationl().toFixed(2) }</span></li>
              <li>L <span className="color-data-value">{ colorsO[1].lightness().toFixed(2) }</span></li>
            </ul>
            <ul>
              <li>H <span className="color-data-value">{ colorsO[1].hue().toFixed(2) }</span></li>
              <li>S <span className="color-data-value">{ colorsO[1].saturationv().toFixed(2) }</span></li>
              <li>V <span className="color-data-value">{ colorsO[1].lightness().toFixed(2) }</span></li>
            </ul>
            <ul>
              <li>C <span className="color-data-value">{ colorsO[1].cyan().toFixed(2) }</span></li>
              <li>M <span className="color-data-value">{ colorsO[1].magenta().toFixed(2) }</span></li>
              <li>Y <span className="color-data-value">{ colorsO[1].yellow().toFixed(2) }</span></li>
              <li>K <span className="color-data-value">{ colorsO[1].black().toFixed(2) }</span></li>
            </ul>
            </div>
          </div>

          <div className="col-2">

            <div className="a-color" style={ { backgroundColor: this.state.colorPalette[2] } }>
            </div>
            <div className="color-data" style={ { color: contrastsE[0] } }>
            <p>{ this.state.colorPalette[2] }</p>
            <ul>
              <li>R <span className="color-data-value">{ colorsO[2].red() }</span></li>
              <li>G <span className="color-data-value">{ colorsO[2].green() }</span></li>
              <li>B <span className="color-data-value">{ colorsO[2].blue() }</span></li>
            </ul>
            <ul>
              <li>H <span className="color-data-value">{ colorsO[2].hue().toFixed(2) }</span></li>
              <li>S <span className="color-data-value">{ colorsO[2].saturationl().toFixed(2) }</span></li>
              <li>L <span className="color-data-value">{ colorsO[2].lightness().toFixed(2) }</span></li>
            </ul>
            <ul>
              <li>H <span className="color-data-value">{ colorsO[2].hue().toFixed(2) }</span></li>
              <li>S <span className="color-data-value">{ colorsO[2].saturationv().toFixed(2) }</span></li>
              <li>V <span className="color-data-value">{ colorsO[2].lightness().toFixed(2) }</span></li>
            </ul>
            <ul>
              <li>C <span className="color-data-value">{ colorsO[2].cyan().toFixed(2) }</span></li>
              <li>M <span className="color-data-value">{ colorsO[2].magenta().toFixed(2) }</span></li>
              <li>Y <span className="color-data-value">{ colorsO[2].yellow().toFixed(2) }</span></li>
              <li>K <span className="color-data-value">{ colorsO[2].black().toFixed(2) }</span></li>
            </ul>
            </div>
          </div>

          <div className="col-2">
            <div className="a-color" style={ { backgroundColor: this.state.colorPalette[3] } }>
            </div>
            <div className="color-data" style={ { color: contrastsE[0] } }>
            <p>{ this.state.colorPalette[3] }</p>
            <ul>
              <li>R <span className="color-data-value">{ colorsO[3].red() }</span></li>
              <li>G <span className="color-data-value">{ colorsO[3].green() }</span></li>
              <li>B <span className="color-data-value">{ colorsO[3].blue() }</span></li>
            </ul>
            <ul>
              <li>H <span className="color-data-value">{ colorsO[3].hue().toFixed(2) }</span></li>
              <li>S <span className="color-data-value">{ colorsO[3].saturationl().toFixed(2) }</span></li>
              <li>L <span className="color-data-value">{ colorsO[3].lightness().toFixed(2) }</span></li>
            </ul>
            <ul>
              <li>H <span className="color-data-value">{ colorsO[3].hue().toFixed(2) }</span></li>
              <li>S <span className="color-data-value">{ colorsO[3].saturationv().toFixed(2) }</span></li>
              <li>V <span className="color-data-value">{ colorsO[3].lightness().toFixed(2) }</span></li>
            </ul>
            <ul>
              <li>C <span className="color-data-value">{ colorsO[3].cyan().toFixed(2) }</span></li>
              <li>M <span className="color-data-value">{ colorsO[3].magenta().toFixed(2) }</span></li>
              <li>Y <span className="color-data-value">{ colorsO[3].yellow().toFixed(2) }</span></li>
              <li>K <span className="color-data-value">{ colorsO[3].black().toFixed(2) }</span></li>
            </ul>
            </div>
          </div>

          <div className="col-2">
            <div className="a-color" style={ { backgroundColor: this.state.colorPalette[4] } }>
            </div>
            <div className="color-data" style={ { color: contrastsE[0] } }>
            <p>{ this.state.colorPalette[4] }</p>
            <ul>
              <li>R <span className="color-data-value">{ colorsO[4].red() }</span></li>
              <li>G <span className="color-data-value">{ colorsO[4].green() }</span></li>
              <li>B <span className="color-data-value">{ colorsO[4].blue() }</span></li>
            </ul>
            <ul>
              <li>H <span className="color-data-value">{ colorsO[4].hue().toFixed(2) }</span></li>
              <li>S <span className="color-data-value">{ colorsO[4].saturationl().toFixed(2) }</span></li>
              <li>L <span className="color-data-value">{ colorsO[4].lightness().toFixed(2) }</span></li>
            </ul>
            <ul>
              <li>H <span className="color-data-value">{ colorsO[4].hue().toFixed(2) }</span></li>
              <li>S <span className="color-data-value">{ colorsO[4].saturationv().toFixed(2) }</span></li>
              <li>V <span className="color-data-value">{ colorsO[4].lightness().toFixed(2) }</span></li>
            </ul>
            <ul>
              <li>C <span className="color-data-value">{ colorsO[4].cyan().toFixed(2) }</span></li>
              <li>M <span className="color-data-value">{ colorsO[4].magenta().toFixed(2) }</span></li>
              <li>Y <span className="color-data-value">{ colorsO[4].yellow().toFixed(2) }</span></li>
              <li>K <span className="color-data-value">{ colorsO[4].black().toFixed(2) }</span></li>
            </ul>
            </div>
          </div>

        </div>

    </div>

      <div className="brand-section" style={{ padding: "50px", color: "#000", backgroundColor: "#fff"}}>
        <div className="row">
        <div className="col-6">
        <div className="brand-guideline-subtitle">
          Social Media
        </div>
        </div>

        <div className="col-6">
          <h1>Your Brand perfectly sized everywhere</h1>
          <p>
            Every social network requires the right dimensions for avatars, header images or posts.
            Just scroll to the social network and download the perfectly sized image for your Brand.
          </p>
        </div>
      </div>

    </div>

      <div className="brand-section" style={{ padding: "50px", color: "#fff", backgroundColor: "#3b5998"}}>

        <div className="brand-guideline-subtitle">
          Facebook
        </div>

        <div className="">
          <h2>Profile Image</h2>
        </div>
        <div className="row" style={{ textAlign: "right" }}>
          <div className="col-2">
            <div className="canvas-wrapper">
              <div className="canvas-dim"><h1>340 x 340</h1></div>
              <canvas ref="facebookProfileLight" id="brand-guideline-canvas-facebook-avatar" data-paper-hidpi="false" />
            </div>
            <canvas ref="facebookProfileLightThumb" data-paper-hidpi="true" />
            <div className="brand-guideline-button">
              <a href="/export" onClick={ (evt) => { this.saveCanvas(evt, "facebookProfileLight") } }>
                <i className="fa fa-arrow-down user-icon"></i> Download
              </a>
            </div>
          </div>
          <div className="col-2">
            <div className="canvas-wrapper">
              <div className="canvas-dim"><h1>340 x 340</h1></div>
              <canvas ref="facebookProfilePalette" id="brand-guideline-canvas-facebook-avatar" data-paper-hidpi="false" />
            </div>
            <canvas ref="facebookProfilePaletteThumb" data-paper-hidpi="true" />
            <div className="brand-guideline-button">
              <a href="/export" onClick={ (evt) => { this.saveCanvas(evt, "facebookProfilePalette") } }>
                <i className="fa fa-arrow-down user-icon"></i> Download
              </a>
            </div>
          </div>
          { svg.dark
            ?
            <div className="col-2">
              <div className="canvas-wrapper">
                <div className="canvas-dim"><h1>340 x 340</h1></div>
                <canvas ref="facebookProfileDark" data-paper-hidpi="false" />
              </div>
              <canvas ref="facebookProfileDarkThumb" data-paper-hidpi="true"/>
              <div className="brand-guideline-button">
                <a href="/export" onClick={ (evt) => { this.saveCanvas(evt, "facebookProfileDark") } }>
                  <i className="fa fa-arrow-down user-icon"></i> Download
                </a>
              </div>
            </div>
            : null
          }
        </div>


        <div className="">
          <h2>Cover / Page header</h2>
        </div>
        <div className="row" style={{ textAlign: "right" }}>
          <div className="col-4">
            <div className="canvas-wrapper">
              <div className="canvas-dim"><h1>1200 x 675</h1></div>
              <canvas ref="facebookCoverLight" id="brand-guideline-canvas-facebook-page-header" data-paper-hidpi="false" />
            </div>
            <canvas ref="facebookCoverLightThumb" data-paper-hidpi="true"/>
            <div className="brand-guideline-button">
              <a href="/export" onClick={ (evt) => { this.saveCanvas(evt, "facebookCoverLight") } }>
                <i className="fa fa-arrow-down user-icon"></i> Download
              </a>
            </div>
          </div>
          <div className="col-4">
            <div className="canvas-wrapper">
              <div className="canvas-dim"><h1>1200 x 675</h1></div>
              <canvas ref="facebookCoverPalette" id="brand-guideline-canvas-facebook-page-header" data-paper-hidpi="false" />
            </div>
            <canvas ref="facebookCoverPaletteThumb" data-paper-hidpi="true"/>
            <div className="brand-guideline-button">
              <a href="/export" onClick={ (evt) => { this.saveCanvas(evt, "facebookCoverPalette") } }>
                <i className="fa fa-arrow-down user-icon"></i> Download
              </a>
            </div>
          </div>
          { svg.dark
            ?
            <div className="col-4">
              <div className="canvas-wrapper">
                <div className="canvas-dim"><h1>1200 x 675</h1></div>
                <canvas ref="facebookCoverDark" data-paper-hidpi="false" />
              </div>
              <canvas ref="facebookCoverDarkThumb" data-paper-hidpi="true"/>
              <div className="brand-guideline-button">
                <a href="/export" onClick={ (evt) => { this.saveCanvas(evt, "facebookCoverDark") } }>
                  <i className="fa fa-arrow-down user-icon"></i> Download
                </a>
              </div>
            </div>
            : null
          }
        </div>

    </div>

      <div className="brand-section" style={{ padding: "50px", color: "#fff", backgroundColor: "#55acee"}}>

        <div className="brand-guideline-subtitle">
          Twitter
        </div>

        <div className="">
          <h2>Profile Photo</h2>
        </div>
        <div className="row" style={{ textAlign: "right" }}>
          <div className="col-3">
            <div className="canvas-wrapper">
              <div className="canvas-dim"><h1>400 x 400</h1></div>
              <canvas className="wrapped-canvas" ref="twitterProfileLight" id="brand-guideline-canvas-twitter-avatar" data-paper-hidpi="false"/>
            </div>
            <canvas ref="twitterProfileLightThumb" data-paper-hidpi="true"/>
            <div className="brand-guideline-button">
              <a href="/export" onClick={ (evt) => { this.saveCanvas(evt, "twitterProfileLight") } }>
                <i className="fa fa-arrow-down user-icon"></i> Download
              </a>
            </div>
          </div>
          <div className="col-3">
            <div className="canvas-wrapper">
              <div className="canvas-dim"><h1>400 x 400</h1></div>
              <canvas className="wrapped-canvas" ref="twitterProfilePalette" id="brand-guideline-canvas-twitter-avatar" data-paper-hidpi="false"/>
            </div>
            <canvas ref="twitterProfilePaletteThumb" data-paper-hidpi="true"/>
            <div className="brand-guideline-button">
              <a href="/export" onClick={ (evt) => { this.saveCanvas(evt, "twitterProfilePalette") } }>
                <i className="fa fa-arrow-down user-icon"></i> Download
              </a>
            </div>
          </div>
          { svg.dark
            ?
            <div className="col-3">
              <div className="canvas-wrapper">
                <div className="canvas-dim"><h1>400 x 400</h1></div>
                <canvas className="wrapped-canvas" ref="twitterProfileDark" id="brand-guideline-canvas-twitter-avatar" data-paper-hidpi="false"/>
              </div>
              <canvas ref="twitterProfileDarkThumb" data-paper-hidpi="true"/>
              <div className="brand-guideline-button">
                <a href="/export" onClick={ (evt) => { this.saveCanvas(evt, "twitterProfileDark") } }>
                  <i className="fa fa-arrow-down user-icon"></i> Download
                </a>
              </div>
            </div>
            : null
          }
        </div>

        <div className="">
          <h2>Header Image</h2>
        </div>
        <div className="row" style={{ textAlign: "right" }}>
          <div className="col-4">
            <div className="canvas-wrapper">
              <div className="canvas-dim"><h1>1500 x 500</h1></div>
              <canvas ref="twitterCoverLight" id="brand-guideline-canvas-twitter-page-header" data-paper-hidpi="false"/>
            </div>
            <canvas ref="twitterCoverLightThumb" data-paper-hidpi="true"/>
            <div className="brand-guideline-button">
              <a href="/export" onClick={ (evt) => { this.saveCanvas(evt, "twitterCoverLight") } }>
                <i className="fa fa-arrow-down user-icon"></i> Download
              </a>
            </div>
          </div>
          <div className="col-4">
            <div className="canvas-wrapper">
              <div className="canvas-dim"><h1>1500 x 500</h1></div>
              <canvas ref="twitterCoverPalette" id="brand-guideline-canvas-twitter-page-header" data-paper-hidpi="false"/>
            </div>
            <canvas ref="twitterCoverPaletteThumb" data-paper-hidpi="true"/>
            <div className="brand-guideline-button">
              <a href="/export" onClick={ (evt) => { this.saveCanvas(evt, "twitterCoverPalette") } }>
                <i className="fa fa-arrow-down user-icon"></i> Download
              </a>
            </div>
          </div>
          { svg.dark
            ?
            <div className="col-4">
              <div className="canvas-wrapper">
                <div className="canvas-dim"><h1>1500 x 500</h1></div>
                <canvas ref="twitterCoverDark" id="brand-guideline-canvas-twitter-page-header" data-paper-hidpi="false"/>
              </div>
              <canvas ref="twitterCoverDarkThumb" data-paper-hidpi="true"/>
              <div className="brand-guideline-button">
                <a href="/export" onClick={ (evt) => { this.saveCanvas(evt, "twitterCoverDark") } }>
                  <i className="fa fa-arrow-down user-icon"></i> Download
                </a>
              </div>
            </div>
            : null
          }
        </div>

    </div>

      <div className="brand-section" style={{ padding: "50px", color: "#fff", backgroundColor: "#e95950"}}>
        <div className="brand-guideline-subtitle">
          Instagram
        </div>

          <div className="">
            <h2>Profile Picture / Avatar</h2>
          </div>
          <div className="row" style={{ textAlign: "right" }}>
            <div className="col-2">
              <div className="canvas-wrapper">
                <div className="canvas-dim"><h1>180 x 180</h1></div>
                <canvas className="wrapped-canvas" ref="instagramProfileLight" id="brand-guideline-canvas-instagram-avatar" data-paper-hidpi="false"/>
              </div>
              <canvas ref="instagramProfileLightThumb" style={{ "border-radius":"50%" }} data-paper-hidpi="true"/>
              <div className="brand-guideline-button">
                <a href="/export" onClick={ (evt) => { this.saveCanvas(evt, "instagramProfileLight") } }>
                  <i className="fa fa-arrow-down user-icon"></i> Download
                </a>
              </div>
            </div>
            <div className="col-2">
              <div className="canvas-wrapper">
                <div className="canvas-dim"><h1>180 x 180</h1></div>
                <canvas className="wrapped-canvas" ref="instagramProfilePalette" id="brand-guideline-canvas-instagram-avatar" data-paper-hidpi="false"/>
              </div>
              <canvas ref="instagramProfilePaletteThumb" style={{ "border-radius":"50%" }} data-paper-hidpi="true"/>
              <div className="brand-guideline-button">
                <a href="/export" onClick={ (evt) => { this.saveCanvas(evt, "instagramProfilePalette") } }>
                  <i className="fa fa-arrow-down user-icon"></i> Download
                </a>
              </div>
            </div>
            { svg.dark
              ?
              <div className="col-2">
                <div className="canvas-wrapper">
                  <div className="canvas-dim"><h1>180 x 180</h1></div>
                  <canvas className="wrapped-canvas" ref="instagramProfileDark" id="brand-guideline-canvas-instagram-avatar" data-paper-hidpi="false"/>
                </div>
                <canvas ref="instagramProfileDarkThumb" style={{ "border-radius":"50%" }} data-paper-hidpi="true"/>
                <div className="brand-guideline-button">
                  <a href="/export" onClick={ (evt) => { this.saveCanvas(evt, "instagramProfileDark") } }>
                    <i className="fa fa-arrow-down user-icon"></i> Download
                  </a>
                </div>
              </div>
              : null
            }
          </div>

    </div>

      <div className="brand-section" style={{ padding: "50px", color: "#fff", backgroundColor: "#007bb5"}}>
        <div className="brand-guideline-subtitle">
          Linkedin
        </div>

        <div className="">
          <h2>Profile Photo</h2>
        </div>
        <div className="row" style={{ textAlign: "right" }}>
          <div className="col-2">
            <div className="canvas-wrapper">
              <div className="canvas-dim"><h1>300 x 300</h1></div>
              <canvas className="wrapped-canvas" ref="linkedinProfileLight" id="brand-guideline-canvas-linkedin-avatar" data-paper-hidpi="false"/>
            </div>
            <canvas ref="linkedinProfileLightThumb" data-paper-hidpi="true"/>
            <div className="brand-guideline-button">
              <a href="/export" onClick={ (evt) => { this.saveCanvas(evt, "linkedinProfileLight") } }>
                <i className="fa fa-arrow-down user-icon"></i> Download
              </a>
            </div>
          </div>
          <div className="col-2">
            <div className="canvas-wrapper">
              <div className="canvas-dim"><h1>300 x 300</h1></div>
              <canvas className="wrapped-canvas" ref="linkedinProfilePalette" id="brand-guideline-canvas-linkedin-avatar" data-paper-hidpi="false"/>
            </div>
            <canvas ref="linkedinProfilePaletteThumb" data-paper-hidpi="true"/>
            <div className="brand-guideline-button">
              <a href="/export" onClick={ (evt) => { this.saveCanvas(evt, "linkedinProfilePalette") } }>
                <i className="fa fa-arrow-down user-icon"></i> Download
              </a>
            </div>
          </div>
          { svg.dark
            ?
            <div className="col-2">
              <div className="canvas-wrapper">
                <div className="canvas-dim"><h1>300 x 300</h1></div>
                <canvas className="wrapped-canvas" ref="linkedinProfileDark" id="brand-guideline-canvas-linkedin-avatar" data-paper-hidpi="false"/>
              </div>
              <canvas ref="linkedinProfileDarkThumb" data-paper-hidpi="true"/>
              <div className="brand-guideline-button">
                <a href="/export" onClick={ (evt) => { this.saveCanvas(evt, "linkedinProfileDark") } }>
                  <i className="fa fa-arrow-down user-icon"></i> Download
                </a>
              </div>
            </div>
            : null
          }
        </div>

        <div className="">
          <h2>Header Image</h2>
        </div>
        <div className="row" style={{ textAlign: "right" }}>
          <div className="col-4">
            <div className="canvas-wrapper">
              <div className="canvas-dim"><h1>1536 x 768</h1></div>
              <canvas ref="linkedinCoverLight" id="brand-guideline-canvas-linkedin-page-header" data-paper-hidpi="false"/>
            </div>
            <canvas ref="linkedinCoverLightThumb" data-paper-hidpi="true"/>
            <div className="brand-guideline-button">
              <a href="/export" onClick={ (evt) => { this.saveCanvas(evt, "linkedinCoverLight") } }>
                <i className="fa fa-arrow-down user-icon"></i> Download
              </a>
            </div>
          </div>
          <div className="col-4">
            <div className="canvas-wrapper">
              <div className="canvas-dim"><h1>1536 x 768</h1></div>
              <canvas ref="linkedinCoverPalette" id="brand-guideline-canvas-linkedin-page-header" data-paper-hidpi="false"/>
            </div>
            <canvas ref="linkedinCoverPaletteThumb" data-paper-hidpi="true"/>
            <div className="brand-guideline-button">
              <a href="/export" onClick={ (evt) => { this.saveCanvas(evt, "linkedinCoverPalette") } }>
                <i className="fa fa-arrow-down user-icon"></i> Download
              </a>
            </div>
          </div>
          { svg.dark
            ?
            <div className="col-4">
              <div className="canvas-wrapper">
                <div className="canvas-dim"><h1>1536 x 768</h1></div>
                <canvas ref="linkedinCoverDark" id="brand-guideline-canvas-linkedin-page-header" data-paper-hidpi="false"/>
              </div>
              <canvas ref="linkedinCoverDarkThumb" data-paper-hidpi="true"/>
              <div className="brand-guideline-button">
                <a href="/export" onClick={ (evt) => { this.saveCanvas(evt, "linkedinCoverDark") } }>
                  <i className="fa fa-arrow-down user-icon"></i> Download
                </a>
              </div>
            </div>
            : null
          }
        </div>
        </div>

  <div className="brand-bottom">
    <a href="/">automagic . design</a>
  </div>

</div>
    )
  }
}

export default BrandGuideline



// WEBPACK FOOTER //
// ./src/components/BrandGuideline.js